var map = {
	"./apartment.svg": "97c3",
	"./apartment_active.svg": "c6d2",
	"./garage.svg": "cd08",
	"./garage_active.svg": "da64",
	"./garden.svg": "c3e5",
	"./garden_active.svg": "28de",
	"./hotel.svg": "1425",
	"./hotel_active.svg": "c172",
	"./house.svg": "0a17",
	"./house_active.svg": "360b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8510";